import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { fmtDateTime } from "@/api";
import { Card } from "@/components/ui/card";

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(true);
  useEffect(() => {
    api.get("/audit-logs").then((response) => setRows(response.data))
      .catch((error) => toast.error(error.response?.data?.detail || "Audit log could not be loaded"))
      .finally(() => setBusy(false));
  }, []);

  return (
    <div className="space-y-5" data-testid="audit-log-page">
      <div><h1 className="font-heading text-2xl font-bold tracking-tight">Audit Log</h1><p className="text-sm text-muted-foreground">Workspace changes and account activity.</p></div>
      <Card className="overflow-x-auto">
        <table className="w-full min-w-[720px] text-sm">
          <thead className="bg-muted/60"><tr className="text-left text-xs uppercase tracking-wide text-muted-foreground">
            <th className="px-3 py-3">When</th><th className="px-3 py-3">User</th><th className="px-3 py-3">Action</th><th className="px-3 py-3">Entity</th><th className="px-3 py-3">Detail</th>
          </tr></thead>
          <tbody>{rows.map((row) => <tr key={row.id} className="border-t">
            <td className="px-3 py-3 whitespace-nowrap">{fmtDateTime(row.created_at)}</td><td className="px-3 py-3 font-mono text-xs">{row.user_id}</td>
            <td className="px-3 py-3">{row.action}</td><td className="px-3 py-3">{row.entity}</td><td className="px-3 py-3 max-w-sm truncate" title={row.detail}>{row.detail || "—"}</td>
          </tr>)}
          {!rows.length && <tr><td colSpan={5} className="px-4 py-12 text-center text-muted-foreground">{busy ? "Loading…" : "No audit activity"}</td></tr>}</tbody>
        </table>
      </Card>
    </div>
  );
}